import React, { useRef, useEffect, useContext, useLayoutEffect } from 'react';
import propTypes from 'prop-types';
import { FLAG_DRAWINGS } from '~/Redux/Modules/FeatureFlags';
import { useResizeEffect } from '~/util';
import FeatureFlagView from '../FeatureFlagView';
import { DrawingContext } from './DrawingProvider';

export const DrawingTarget = ({ children, date }) => {
  const ref = useRef();
  const { registerRect } = useContext(DrawingContext);

  useLayoutEffect(() => {
    registerRect(date, ref.current?.getBoundingClientRect());
  }, [date]);

  useResizeEffect(() => {
    registerRect(date, ref.current?.getBoundingClientRect());
  });

  useEffect(() => {
    const onScroll = () => {
      registerRect(date, ref.current?.getBoundingClientRect());
    };
    if (ref.current) {
      let currentElement = ref.current;
      while (currentElement && !currentElement.classList.contains('scroll-child')) {
        currentElement = currentElement.parentElement;
      }
      if (currentElement) {
        currentElement.addEventListener('scroll', onScroll);
        return () => currentElement.removeEventListener('scroll', onScroll);
      }
    }
  });

  return (
    <FeatureFlagView featureName={FLAG_DRAWINGS}>
      <div className="drawing-target" ref={ref}>
        {children}
      </div>
    </FeatureFlagView>
  );
};

DrawingTarget.propTypes = {
  children: propTypes.node,
  date: propTypes.string,
};
